// External dependencies
import { Container, Div } from 'atomize';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper';

// Local dependencies
import aigul from '../../../../assets/images/aigul.jpg';
import aiperi from '../../../../assets/images/aiperi.jpg';
import aizada from '../../../../assets/images/aizada.jpg';
import akmoor from '../../../../assets/images/akmoor.jpg';
import barygul from '../../../../assets/images/barygul.jpg';
import begaiym from '../../../../assets/images/begaiym.jpg';
import madina from '../../../../assets/images/madina.jpg';
import nargiza from '../../../../assets/images/nargiza.jpg';

import '../../styles/styles.scss';
import MeducationBlock from '../meducation-block';
import MeducationReviewCard from './MeducationReviewCard';

export default function MeducationReviews() {
  const reviews = [
    {
      id: 'review1',
      author: 'meducationReviewAuthorBarygul',
      avatar: barygul,
      text: 'meducationReviewTextBarygul',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review2',
      author: 'meducationReviewAuthorAiperi',
      avatar: aiperi,
      text: 'meducationReviewTextAiperi',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review3',
      author: 'meducationReviewAuthorAigul',
      avatar: aigul,
      text: 'meducationReviewTextAigul',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review4',
      author: 'meducationReviewAuthorMadina',
      avatar: madina,
      text: 'meducationReviewTextMadina',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review5',
      author: 'meducationReviewAuthorNargiza',
      avatar: nargiza,
      text: 'meducationReviewTextNargiza',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review6',
      author: 'meducationReviewAuthorBegaiym',
      avatar: begaiym,
      text: 'meducationReviewTextBegaiym',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review7',
      author: 'meducationReviewAuthorAizada',
      avatar: aizada,
      text: 'meducationReviewTextAizada',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
    {
      id: 'review8',
      author: 'meducationReviewAuthorAkmoor',
      avatar: akmoor,
      text: 'meducationReviewTextAkmoor',
      videoLink: 'https://youtu.be/_0xZoh-F-A8?si=lyTuIAreuw9u0CoI',
    },
  ];
  return (
    <Div className="meducation-reviews">
      <MeducationBlock
        blockBg="btn_default_bg"
        blockPadding={{
          t: { xs: '24px', md: '40px' },
          b: { xs: '24px', md: '47px' },
        }}
        blockTitle="whatDoesPharmacistsAndPartnersSay"
        blockTitleColor="bg_black"
        blockTitleTextAlign="left"
      >
        <Container>
          <Div
            maxW="100%"
            m={{ t: { xs: '24px', md: '32px' } }}
            className="meducation-reviews__slider"
          >
            <Swiper
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                600: {
                  spaceBetween: 200,
                },
                800: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
              }}
              pagination={{ clickable: true }}
              navigation
              modules={[Navigation, Pagination]}
            >
              {reviews.map((review) => (
                <SwiperSlide key={review.id}>
                  <MeducationReviewCard
                    author={review.author}
                    text={review.text}
                    avatar={review.avatar}
                    // videoLink={review.videoLink}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Div>
        </Container>
      </MeducationBlock>
    </Div>
  );
}
